import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=2d7dd834&scoped=true&"
import script from "./SiteBanner.vue?vue&type=script&lang=js&"
export * from "./SiteBanner.vue?vue&type=script&lang=js&"
import style0 from "./SiteBanner.vue?vue&type=style&index=0&id=2d7dd834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7dd834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VFlex,VIcon,VImg,VLayout})
